import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { commonApi } from 'hooks/api/common'
import { setHolidays } from 'store/holidaySlice'

export const HolidaysLoader = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    commonApi()
      .getHolidays()
      .then((data) => {
        dispatch(setHolidays(data.data))
      })
  }, [dispatch])

  return null
}
